require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window

ns.GuidesApp = require('./hello_baby/containers/GuidesApp').default

ns.ProductCollection =
  require('./hello_baby/components/ProductCollection').default

ns.ProductSpotlight =
  require('./hello_baby/components/ProductSpotlight').default

ns.PostConfettiBanner =
  require('./hello_baby/components/post-confetti-banner').default

ns.AuthorProfile = require('./hello_baby/components/AuthorProfile').default

// Design system components for old templates until they get updated
const BDButton = require('./baby-design').Button
const BDLinkOutIcon = require('./baby-design/icons').LinkOut

ns.LinkOutButton = ({ children, ...props }) => (
  <BDButton
    {...props}
    icon={{ side: 'right', icon: <BDLinkOutIcon />, size: 'md' }}
  >
    {children}
  </BDButton>
)

ns.PriceTag = require('./baby-design/components/PriceTag/PriceTag.tsx')

ns.ReactRailsUJS = require('react_ujs')
